import React, { useState } from 'react';
import DeleteRecordModal from '../../../ViewComponents/DeleteRecordModal';
import { useNavigate, useParams } from 'react-router-dom';

const RenderJSON = ({ data, path = [], expandedState, toggleExpanded, objectIndex }) => {
    const renderValue = (value, keyPath) => {
        const getValueClass = (value) => {
            if (typeof value === 'string') return 'string_val';
            if (typeof value === 'number') return 'num_val';
            if (typeof value === 'boolean') return 'bool_val';
            if (Array.isArray(value)) return 'array_val';
            if (typeof value === 'object' && value !== null) return 'object_val';
            return '';
        };

        const valueClass = getValueClass(value);

        if (typeof value === 'object' && value !== null) {
            return (
                <div className="object_box">
                    {expandedState[keyPath] && (
                        <RenderJSON data={value} path={keyPath} expandedState={expandedState} toggleExpanded={toggleExpanded} />
                    )}
                </div>
            );
        } else {
            return <span className={valueClass}>{JSON.stringify(value)}</span>;
        }
    };

    const generateUniqueKey = (key, keyPath) => {
        return [...keyPath, key].join('-');
    };

    return (
        <div>
            {Array.isArray(data) ? (
                <div className="item_array">
                    {data.map((item, index) => {
                        const keyPath = [...path, index];
                        const uniqueKey = generateUniqueKey(index, path);
                        return (
                            <div key={uniqueKey} className="item_array_inner">
                                <div className="key-value-pair">
                                    <span className='key_items'>{index}: </span>
                                    {renderValue(item, keyPath)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="item_object">
                    {Object.keys(data)
                        .sort((a, b) => (a === '_id' ? -1 : b === '_id' ? 1 : 0))
                        .map((key) => {
                            const keyPath = [...path, key];
                            const uniqueKey = generateUniqueKey(key, path);
                            const value = data[key];

                            const isComplex = typeof value === 'object' && value !== null;

                            return (
                                <div key={uniqueKey} className="key-value-pair">
                                    <strong className='key_items'>{key}: </strong>

                                    {isComplex && (
                                        <button onClick={() => toggleExpanded(keyPath)} className="object_toggle_btn">
                                            {expandedState[keyPath] ? (
                                                <>
                                                    <i className="fa-solid fa-chevron-down"></i>
                                                    Object
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-chevron-right"></i>
                                                    Object
                                                </>
                                            )}
                                        </button>
                                    )}

                                    {renderValue(value, keyPath)}
                                </div>
                            );
                        })}
                </div>
            )}
        </div>
    );
};

const OpenCollectionJson = ({ collectionData, fetchCollection, pageData }) => {
    const user_id = sessionStorage.getItem("user_id");
    const navigate = useNavigate();
    const { project_id, db_id, coll_id } = useParams()
    const [expandedState, setExpandedState] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [recordObject, setRecordObject] = useState({})


    const toggleExpanded = (path) => {
        setExpandedState((prevState) => ({
            ...prevState,
            [path]: !prevState[path],
        }));
    };

    const handleOpenDelete = (recordId) => {
        setShowDeleteModal(true)
        const selectedRecord = collectionData.find((item) => item._id === recordId);
        if (selectedRecord) {
            const obj = {
                _id: {
                    db_id: db_id,
                    coll_id: coll_id,
                    item_id: selectedRecord._id
                }
            }
            setRecordObject(obj)
        }
    }

    const fetchRecords = () => {
        if (user_id && db_id && coll_id && pageData) {
            fetchCollection(user_id, db_id, coll_id, pageData)
        }
    }

    const handleClose = () => {
        setShowDeleteModal(false)
        setRecordObject({})
    }

    return (
        <div className="json_object">
            {collectionData.map((item, index) => {
                const keyPath = [index];

                return (
                    <div key={index} className="json_item">
                        <div className="object_number_cont">
                            <p className='object_number'>{index + 1}</p>
                            <div className='object_actions_cont'>
                                <button className='object_action_btn_delete' onClick={() => handleOpenDelete(item._id)}><i className='fa-solid fa-trash'></i></button>
                            </div>
                        </div>

                        <RenderJSON
                            data={item}
                            path={keyPath}
                            expandedState={expandedState}
                            toggleExpanded={toggleExpanded}
                            objectIndex={index}
                        />
                    </div>
                );
            })}
            <DeleteRecordModal
                show={showDeleteModal}
                handleClose={handleClose}
                recordObject={recordObject}
                fetchRecords={fetchRecords}
                endpoint={"delete_collection_record"}
                record_type={"Delete"}
                message="This action CANNOT be undone. It will permanently delete the resource and all associated data."
            />
        </div>

    );
};

export default OpenCollectionJson;
